import React from "react";

const Rectangle = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
    >
      <path
        d="M14.2222 0H1.77778C0.8 0 0 0.771429 0 1.71429V10.2857C0 11.2286 0.8 12 1.77778 12H14.2222C15.2 12 16 11.2286 16 10.2857V1.71429C16 0.771429 15.2 0 14.2222 0ZM14.2222 10.2857H1.77778V1.71429H14.2222V10.2857Z"
        fill={color}
      />
    </svg>
  );
};

export default Rectangle;
